import { Component, Input, NgZone, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BannerStateService } from './vendor-advertisement-banner.service';

@Component({
  selector: 'cygov-vendor-advertisement-banner',
  templateUrl: './vendor-advertisement-banner.component.html',
  styleUrl: './vendor-advertisement-banner.component.scss',
  animations: [
    trigger('fadeInOutAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate('1000ms ease-in')]),
      transition(':leave', [style({ opacity: 1 }), animate('500ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class VendorAdvertisementBannerComponent implements OnInit, OnDestroy {
  @Input() bannerId!: number;
  @Input() paragraphText!: string;
  @Input() buttonText!: string;
  @Input() bannerClass!: string;
  @Input() linkUrl: string;
  @Input() ctaLink!: string;
  @Input() user: any;

  currentActiveBanner = 0;
  rotationInterval: any;
  visible = false;

  constructor(private bannerStateService: BannerStateService) {}
  ngOnInit(): void {
    this.visible = this.bannerStateService.shouldShowBanner(this.bannerId);
  }

  get backgroundClass(): string {
    if (this.bannerId === 1) {
      return 'banner1-image';
    } // First Header Banner
    if (this.bannerId === 2) {
      return 'banner2-image';
    } // Footer Banner
    if (this.bannerId === 3) {
      return 'banner3-image';
    } // Second Header Banner
    return this.bannerClass;
  }

  get formattedParagraphText(): string {
    // Only apply bold to the word 'GRC'
    return this.paragraphText.replace(/(GRC)/g, '<strong>$1</strong>');
  }

  getDemoLink(): string {
    if (!this.user) {
      return '#';
    }
    const name = encodeURIComponent(this.user.name || '');
    const email = encodeURIComponent(this.user.email || '');
    return `https://resources.centraleyes.com/thank-you-demo-request?name=${name}&email=${email}`;
  }

  startRotation() {
    const order = [1, 2, 3, 2];
    let i = 0;

    this.rotationInterval = setInterval(() => {
      this.currentActiveBanner = order[i];
      this.visible = this.currentActiveBanner === this.bannerId;
      i = (i + 1) % order.length;
    }, 8000);
  }

  ngOnDestroy(): void {
    clearInterval(this.rotationInterval);
  }
}
